/**
 * Territory-owner assignment. A plan that arrives from the EHR plots onto the
 * clinician who owns the patient's territory for that discipline — 2.1's PT
 * orders land on Ana this way. It is a configuration on top of the product's
 * own two-stage assignment, not a replacement for it.
 */
import type { DemoState, Discipline } from "@caredna-marlin/utils/homeHealthDemo/state";
import { disciplineGroupFor, ownsTerritory, rosterEntries } from "./roster";

/**
 * The clinician who owns a territory for a discipline: an exact discipline match
 * first (North SN is Dana, not the LPN who also owns North), then the discipline
 * group. Alphabetical when a branch has more than one, so the answer is stable.
 */
export function ownerFor(state: DemoState, territory: string | undefined, discipline: Discipline): string | undefined {
  if (!territory) return undefined;
  const owners = rosterEntries(state)
    .filter((e) => ownsTerritory(e, territory))
    .sort((a, b) => a.displayName.localeCompare(b.displayName));
  return (owners.find((e) => e.discipline === discipline) ?? owners.find((e) => disciplineGroupFor(e.discipline) === disciplineGroupFor(discipline)))?.handle;
}
